export default {
  TEN: 10,
  TWENTYFIVE: 25,
  FIFTY: 50,
  HUNDRED: 100,
};
